import React, { useEffect, useState } from "react";
import styles from "./Input.module.css";

const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className = "", style, ...props }, ref) => {
    const [theme, setTheme] = useState({
      background: "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
      border: "rgba(255,255,255,0.15)",
      placeholder: "rgba(255,255,255,0.4)",
    });

    useEffect(() => {
      const tgTheme = window.Telegram?.WebApp?.themeParams;
      if (tgTheme) {
        setTheme({
          background: "linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))",
          border: "rgba(255,255,255,0.15)",
          placeholder: tgTheme.hint_color || "rgba(255,255,255,0.4)",
        });
      }
    }, []);

    return (
      <input
        ref={ref}
        className={`${styles.input} ${className}`}
        style={{
          background: theme.background,
          color: "#fff", // <--- фиксируем белый текст
          borderColor: theme.border,
          ...style,
        }}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export default Input;
